<template>
  <div>
    <form-label v-if="isSelecting && formStyle !== 'parcelUpdate'" :dark="formStyle === 'detail'">
      Contact
    </form-label>

    <div v-if="isSelecting">
      <div v-if="!isEditing" class="row">
        <div class="col6">
          <form-filtered-select
            :options="contacts"
            :selected-key="selectedContact ? selectedContact.value : null"
            :invalid="invalid"
            placeholder=""
            @updateDropdownValue="onContactSelected" />
        </div>
        <form-button
          v-if="selectedContact && selectedContact.value"
          class="col1"
          @onClick="editExisting">
          Edit
        </form-button>
        <form-button
          class="col1"
          @onClick="addNewContact">
          New
        </form-button>
      </div>
      <div v-if="isEditing" class="row">
        <div class="col4">
          <form-input
            v-model="name"
            :required="false"
            placeholder="Contact Name" />
        </div>
        <div class="col4">
          <form-input
            v-model="phone"
            :required="true"
            placeholder="Contact Phone" />
        </div>
        <form-button
          :secondary="true"
          class="col1"
          @onClick="cancelContactEdit">
          Cancel
        </form-button>
        <form-button
          class="col1"
          @onClick="saveContact">
          Save
        </form-button>
      </div>
    </div>
    <div v-else class="row">
      <div class="col12 spl-parcel-detail-contact-show">
        <span>{{ (name && name.length > 0) ? name + ' (' + phone + ')' : phone }}</span>
      </div>
    </div>
    <br>
  </div>
</template>

<script lang="ts">

import webApi from '@/webApi'
import { find } from 'lodash'
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { ContactModel } from '@/webApi/DataModels'
import constants from '@/constants'

export default Vue.extend({
  props: ['parcelData', 'isSelecting', 'formStyle', 'invalid'],
  data () {
    return {
      selectedContact: {},
      contactData: {},
      isEditing: false,
      isNew: false,
      name: '',
      phone: '',
      contactID: -1
    }
  },
  computed: {
    // Map the contacts from the vuex store
    ...mapGetters('contact', ['contacts'])
  },
  watch: {
    parcelData: {
      handler: function (newVal) {
        // Everytime we get a parcel or booking from the outside we set the selected value
        this.createContactData(newVal)
        this.name = this.parcelContact.Contact_Name || ''
        this.phone = this.parcelContact.Contact_Phone || ''
      },
      deep: true
    },
    contacts: {
      handler: function (newVal) {
        // Everytime the contactlist updates we check if the selected value is (still) there
        this.checkSelectionFromParcel()
      }
    }
  },
  created () {
    this.createContactData(this.parcelData)
    this.name = this.parcelContact.Contact_Name || ''
    this.phone = this.parcelContact.Contact_Phone || ''
  },
  methods: {
    ...mapActions('contact', ['getContacts']),
    // TODO remove this when backend is changed from parcel detail and booking format to the same
    createContactData (parcelData) {
      this.parcelContact = {}
      if (this.parcelData && this.parcelData.Contact) {
        this.parcelContact = this.parcelData.Contact
      } else if (this.parcelData && this.parcelData.Contact_ID !== -1) {
        this.parcelContact = {
          Contact_ID: this.parcelData.Contact_ID,
          Contact_Name: this.parcelData.Contact_Name,
          Contact_Phone: this.parcelData.Contact_Phone
        }
      }
      this.checkSelectionFromParcel()
    },
    // Tries to select the contact from the parcel/booking data
    checkSelectionFromParcel () {
      if (this.contacts.length > 0 && (!this.selectedContact || !this.selectedContact.Contact_ID) && this.parcelContact && this.parcelContact.Contact_ID !== -1) {
        this.selectedContact = find(this.contacts, { value: this.parcelContact.Contact_ID })
      }
    },
    // updates all values if a contact is selected
    onContactSelected (value) {
      if (!value) {
        this.selectedContact = null
        this.name = ''
        this.phone = ''
        this.$emit('contactSelected', value)
      } else {
        this.selectedContact = value
        this.name = this.selectedContact.Contact_Name || ''
        this.phone = this.selectedContact.Contact_Phone || ''
        this.$emit('contactSelected', value)
      }
    },
    // Changes the mode to editing a
    editExisting () {
      this.isEditing = true
      this.isNew = false
      this.name = this.selectedContact.contactItem.Contact_Name || ''
      this.phone = this.selectedContact.contactItem.Phone_Number || ''
      this.contactID = this.selectedContact.contactItem.Contact_ID
    },
    addNewContact () {
      this.isEditing = true
      this.isNew = true
      this.name = ''
      this.phone = ''
      this.contactID = -1
    },
    cancelContactEdit () {
      this.isEditing = false
    },
    saveContact () {
      this.isEditing = false
      var contactItem:ContactModel = {
        Country_ID: this.parcelData.Country_ID,
        Customer_ID: this.parcelData.Customer_ID,
        Phone_Number: ''
      } as ContactModel
      contactItem.Contact_Name = this.name
      contactItem.Phone_Number = this.phone
      // Check if we are adding a contact or editing
      if (this.isNew) {
        webApi.contact.create_Contact(contactItem)
          .then((result) => {
          // when the contact is created select it
            if (result.data as any > 0) {
              this.$toast('Successfully Created', constants.defaultToastOptions())
              this.updateContacts()
              this.selectedContact = null
              this.parcelContact = {
                Contact_ID: result.data as any,
                Contact_Name: this.name,
                Contact_Phone: this.phone
              }
            } else {
              window.bus.$emit('openErrorModal', 'error creating contact')
            }
          }).catch((error) => {
            window.bus.$emit('openErrorModal', 'error creating contact: ' + error.data.ExceptionMessage)
          })
      } else {
        // Update Contact
        contactItem.Contact_ID = this.contactID
        webApi.contact.update_Contact(contactItem)
          .then((result) => {
          // when the contact is created select it
            if (result.data as any > 0) {
              this.$toast('Successfully Updated', constants.defaultToastOptions())
              this.updateContacts()
              this.selectedContact = null
              this.parcelContact = {
                Contact_ID: result.data as any,
                Contact_Name: this.name,
                Contact_Phone: this.phone
              }
            } else {
              window.bus.$emit('openErrorModal', 'error updating contact')
            }
          }).catch((error) => {
            window.bus.$emit('openErrorModal', 'error updating contact: ' + error.data.ExceptionMessage)
          })
      }
    },
    updateContacts () {
      // update the contact list through vuex hook after editing / adding etc
      this.getContacts({
        customerID: this.parcelData.Customer_ID,
        countryID: this.parcelData.Country_ID
      })
    }
  }
})
</script>

<style lang="scss">
  @import '../../variables.scss';
  .spl-parcel-detail-contact {
    &-show {
      font-size: 12px;
      font-weight: 600;
      margin-top: 10px;
    }
  }
</style>
